import React from 'react';
import { ButtonStyle } from '../Styles/UserStyles/CommonButtonStyles';
// import { ButtonStyle } from '../../styles/Utilities/CommonButtonStyles';

const CommonButton = ({ onClick, label }) => {
  return <ButtonStyle onClick={onClick}>{label}</ButtonStyle>;
};

export default CommonButton;
